import { render } from "./TripTable.vue?vue&type=template&id=19cfda44&scoped=true&ts=true"
import script from "./TripTable.vue?vue&type=script&lang=ts"
export * from "./TripTable.vue?vue&type=script&lang=ts"

import "./TripTable.vue?vue&type=style&index=0&id=19cfda44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19cfda44"]])

export default __exports__